@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container allow-wrap">
      <tidy-text
        [header]="'Taxes'" />
      <tidy-image
        src="assets/img/help-circle-outline.svg"
        class="body-size"
        [matTooltip]="'TIDY tracks the jurisdictions for each property, which taxes apply, and files and remits them when due.' | translate"
        [matTooltipPosition]="'below'"
        matTooltipClass="menu-item-tooltip below"
        style="opacity: 0.7" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'taxes'" />
    </div>
  </tidy-desktop-header>
}

@if (!loaded) {
  @if (windowService.isDesktopRes) {
    <tidy-table
      [skeletonLoading]="true"
      [columnslabels]="headers" />
  } @else {
    @for (i of [1,2,3,4,5]; track i) {
      <div style="width: 100%; margin-bottom: 6px;">
        <ion-skeleton-text animated="true" style="height: 92px; border-radius: 6px" />
      </div>
    }
  }
}

@if (loaded && errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (loaded && !errorMessage && properties.length === 0) {
  <tidy-alert>
    <tidy-row>
      <tidy-text
        [body]="'No properties yet.'" />
    </tidy-row>
  </tidy-alert>
}

@if (loaded && !errorMessage && properties.length > 0) {
  <div class="tax-summary-strip">
    <span>{{ summary.properties }} {{ (summary.properties === 1 ? 'property' : 'properties') | translate }}</span>
    <span class="tax-summary-strip__dot"></span>
    <span>{{ summary.taxesTracked }} {{ (summary.taxesTracked === 1 ? 'tax tracked' : 'taxes tracked') | translate }}</span>
    @if (summary.needAttention > 0) {
      <span class="tax-summary-strip__dot"></span>
      <span>{{ summary.needAttention }} {{ 'need attention' | translate }}</span>
    }
    @if (summary.overdue > 0) {
      <span class="tax-summary-strip__dot"></span>
      <span>{{ summary.overdue }} {{ 'overdue' | translate }}</span>
    }
  </div>
}

@if (loaded && !errorMessage && windowService.isDesktopRes && properties.length > 0) {
  <div class="desktop-flex-fill">
    <tidy-table
      [dataSource]="rows"
      [displayedColumns]="headers"
      [columnslabels]="headers"
      [allRowIsClickable]="true"
      [rowsToShow]="25"
      [showColumnLines]="false"
      [blockSorting]="true"
      (cellClick)="onTableColumnClick($event)" />
  </div>
}

@if (loaded && !errorMessage && !windowService.isDesktopRes) {
  @for (property of properties; track property.id) {
    <tidy-card>
      <tidy-card-button
        (action)="openPropertyDetails(property)"
        class="arrow-to-top">
        <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
          <span style="display: inline-flex; align-items: center;">
            <ion-icon name="home" [style.color]="property.color" style="font-size: 16px; margin-right: 6px;" />
            <tidy-text
              [header]="property.name"
              [translate]="false" />
          </span>
          <span
            class="tax-chip"
            [ngStyle]="{ '--chip-fg': toneColor[property.statusTone], '--chip-bg': toneBg[property.statusTone] }">
            <span class="tax-chip__dot"></span>
            {{ property.statusLine | translate }}
          </span>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="property.taxCountLine + ' · ' + property.nextUpLine"
            [class]="property.nextUpOverdue ? 'red' : ''"
            [translate]="false" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
  }
}
